import { CommonHelperFunctions, IComponentDto } from "@kuika/kuika-cl-model";
import Axios, { AxiosResponse } from "axios";
import { KMainFunctions } from "../shared/utility/main-functions";

declare let window: any;
const backendUrl = CommonHelperFunctions.GetBackendUrl();

export class ComponentService {
  public static async Create(component: IComponentDto): Promise<AxiosResponse> {
    try {
      return await Axios.post<IComponentDto, AxiosResponse>(`${backendUrl}/components/create`, component);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async Update(id: string, obj: IComponentDto): Promise<AxiosResponse> {
    try {
      return await Axios.put<IComponentDto, AxiosResponse>(`${backendUrl}/components/${id}`, obj);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async Delete(id: string): Promise<boolean> {
    try {
      await Axios.delete<null>(`${backendUrl}/components/${id}`);
      return true;
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  }

  public static async GetAllByComponentSetId(id: string): Promise<AxiosResponse<IComponentDto[]>> {
    try {
      let data = await Axios.get<null, AxiosResponse<IComponentDto[]>>(
        `${backendUrl}/components/getbycomponentsetid/${id}`
      );
      return data;
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async GetAllRenderers(): Promise<AxiosResponse> {
    try {
      return await Axios.get<IComponentDto, AxiosResponse>(`${backendUrl}/components/renderertypes`);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }
}
